import React, {PropsWithChildren} from 'react';
import styled, {css} from "styled-components";
import {observer} from "mobx-react";
import {ChevronForwardIcon} from "../../assets/svg/chevron-forward.icon";
import {ChevronBackIcon} from "../../assets/svg/chevron-back.icon";



type IconSize = 'small' | 'large';

const NavigationButtonBox = styled.div<{$isVisible: boolean; $disabled: boolean; $iconSize: IconSize}>`
    display: flex;
    align-items: center;
    justify-content: center;
    visibility: ${props => props.$isVisible ? "visible": "hidden"};
    font-size: 30px;
    ${props => props.$disabled
        ? css`
                cursor: not-allowed;
                color: ${props => props.theme.colors.medium};
            `
        : css`
                cursor: pointer;
                color: ${props => props.theme.colors.dark};
            `
        }
    ${props => props.$iconSize === 'large'
            ? css`
                font-size: 26px;
            `
            : css`
                font-size: 20px;
            `
    }
`

interface NavigationButtonComponentProps extends PropsWithChildren {
    isVisible: boolean;
    disabled: boolean;
    iconSize: IconSize;
    onClick?: () => void;
}

const NavigationButtonComponent: React.FC<NavigationButtonComponentProps> = observer((props) => {
    return (
        <NavigationButtonBox $isVisible={props.isVisible} $disabled={props.disabled} onClick={props.onClick} $iconSize={props.iconSize}>
            {props.children}
        </NavigationButtonBox>
    );
})

export const BackNavigationButtonComponent: React.FC<NavigationButtonComponentProps> = observer((props) => {
    return (
        <NavigationButtonComponent {...props}>
            <ChevronBackIcon size={1.4}/>
        </NavigationButtonComponent>
    );
})

export const ForwardNavigationButtonComponent: React.FC<NavigationButtonComponentProps> = observer((props) => {
    return (
        <NavigationButtonComponent {...props}>
            <ChevronForwardIcon size={1.4}/>
        </NavigationButtonComponent>
    );
})
